import BreadcrumbsSchema from "modules/storyblok/components/BreadcrumbsSchema";
import { stickyBottomBarFirstTriggerStyles } from "components/StickyBottomBar";
import StickyBottomBarTrigger from "components/StickyBottomBar/StickyBottomBarTrigger";
import { DataContextProvider } from "contexts/DataContext";
import { useLanguage } from "contexts/LocalizationContext";
import { MobileSideMenu } from "components/MobileSideMenu";
import { ModalContextProvider } from "contexts/ModalContext";
import { StickyBottomBarContextProvider } from "contexts/StickyBottomBarContext";
import CustomHead from "modules/common/components/CustomHead";
import Footer from "modules/common/components/Footer";
import { Grid } from "modules/common/components/Grid";
import { MenuItems, HeaderNav, ViewClaimStatusButton } from "modules/common/components/HeaderNav";
import { PressLogos } from "modules/common/components/PressLogos";
import { useTopMenu } from "hooks/useMenu";
import { Box } from "@chakra-ui/react";
import StickyBottomBarAdapter from "../../adapters/StickyBottomBar";
import CallToAction from "./CallToAction";
import CategoryList from "./CategoryList";
import ContactUs from "./ContactUs";
import Header from "./Header";
import type { HelpHomeTemplateProps } from "./HelpHomeTemplate.d";
import QuestionsAccordion from "./QuestionsAccordion";

const HelpHomeTemplate = ({
  story,
  cmsLanguagesData,
  serverSideStoryblokPages,
  mostCommonQuestionsCategory,
  categories,
  whiteListDomains,
  googleOptimizeExperimentIds,
  nofollowUrls,
}: HelpHomeTemplateProps) => {
  const language = useLanguage();
  const topMenu = useTopMenu(language);

  const {
    tag_list: tagList,
    content: {
      metaTitle,
      metaDescription,
      breadcrumbsParentPage,
      breadcrumbsPositionName,
      stickyBottomBarHeading,
      stickyBottomBarButtonText,
      stickyBottomBarBenefits,
      stickyBottomBarHideBenefits,
      hideStickyBottomBar,
      stickyBottomBarVariant,
    },
  } = story;
  const noindex = tagList.includes("noindex");

  return (
    <DataContextProvider
      data={{ cmsLanguagesData, serverSideStoryblokPages, whiteListDomains, googleOptimizeExperimentIds, nofollowUrls }}
    >
      <CustomHead title={metaTitle} description={metaDescription} noindex={noindex} />
      <BreadcrumbsSchema
        breadcrumbsPositionName={breadcrumbsPositionName}
        breadcrumbsParentPage={breadcrumbsParentPage}
      />
      <MobileSideMenu />
      <ModalContextProvider>
        <HeaderNav menuItems={<MenuItems menu={topMenu} />} headerButton={<ViewClaimStatusButton />} />
        <Box as="main">
          <StickyBottomBarTrigger type="first" styles={stickyBottomBarFirstTriggerStyles} />
          <Header />
          <QuestionsAccordion category={mostCommonQuestionsCategory} />
          <CallToAction />
          <CategoryList categories={categories} />
          <Grid>
            <ContactUs />
          </Grid>
          <PressLogos />
        </Box>
        <Footer />
      </ModalContextProvider>

      <StickyBottomBarAdapter
        showStickyBottomBar={!hideStickyBottomBar}
        stickyBottomBarVariant={stickyBottomBarVariant}
        stickyBottomBarHeading={stickyBottomBarHeading}
        stickyBottomBarButtonText={stickyBottomBarButtonText}
        stickyBottomBarBenefits={stickyBottomBarBenefits}
        stickyBottomBarHideBenefits={stickyBottomBarHideBenefits}
      />
    </DataContextProvider>
  );
};

export const HelpHomeTemplateAdapter = (props: HelpHomeTemplateProps) => (
  <StickyBottomBarContextProvider threshold={0.4}>
    <HelpHomeTemplate {...props} />
  </StickyBottomBarContextProvider>
);
